import AuthenticationService from "../Services/AuthenticationService";

class SecureMediaLoader  
{
    getResourceFileName(resourceLocator) {
        let date = new Date();
        resourceLocator = resourceLocator.replace(/\/$/, '');
        let parts = resourceLocator.split('/');
        let fileName = parts[parts.length - 1];
        fileName = decodeURIComponent(fileName);
        fileName = fileName.replace(/\.[^/.]+$/, '');
        
        return `${fileName}_${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}_${date.getHours()}-${date.getMinutes()}-${date.getSeconds()}-${date.getMilliseconds()}.pdf`;
    }

    async loadSecure(resourceLocator){
        try {
            const response = await fetch(`${AuthenticationService.getBaseUrl()}${resourceLocator}`, {
              headers: AuthenticationService.getAuthHeader()
            });
        
            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }
        
            const contentType = response.headers.get('content-type');
        
            if (contentType === 'video/mp4') {
              const videoUrl = `${AuthenticationService.getBaseUrl()}${resourceLocator}`;
              const newWindow = window.open('', '_blank');
              
              if (newWindow) {
                newWindow.document.write(`
                  <html>
                    <head>
                      <title>Video Player</title>
                    </head>
                    <body style="margin: 0; padding: 0;">
                      <video controls style="width: 100%; height: 100%;">
                        Your browser does not support the video tag.
                      </video>
                      <div id="status" style="position: absolute; top: 10px; left: 10px; color: white; background: rgba(0,0,0,0.5); padding: 5px;">Loading...</div>
                    </body>
                  </html>
                `);
                newWindow.document.close();
        
                const script = newWindow.document.createElement('script');
                script.textContent = `
                  const videoElement = document.querySelector('video');
                  const statusElement = document.getElementById('status');
                  
                  const xhr = new XMLHttpRequest();
                  xhr.open('GET', '${videoUrl}', true);
                  xhr.setRequestHeader('Authorization', '${AuthenticationService.getAuthHeader().Authorization}');
                  xhr.responseType = 'blob';
                  
                  xhr.onprogress = function(event) {
                    if (event.lengthComputable) {
                      const percentComplete = (event.loaded / event.total) * 100;
                      statusElement.textContent = 'Loading: ' + Math.round(percentComplete) + '%';
                    }
                  };
        
                  xhr.onreadystatechange = function() {
                    if (xhr.readyState === 3) {  // LOADING
                      if (xhr.response && xhr.response.size > 0) {
                        const url = URL.createObjectURL(xhr.response);
                        if (videoElement.src !== url) {
                          const currentTime = videoElement.currentTime;
                          videoElement.src = url;
                          videoElement.currentTime = currentTime;
                        }
                      }
                    } else if (xhr.readyState === 4) {  // DONE
                      if (xhr.status === 200) {
                        const url = URL.createObjectURL(xhr.response);
                        videoElement.src = url;
                        statusElement.textContent = 'Video fully loaded';
                      } else {
                        statusElement.textContent = 'Error loading video';
                      }
                    }
                  };
        
                  videoElement.addEventListener('loadedmetadata', () => {
                    statusElement.textContent = 'Metadata loaded, video is ready to play';
                  });
        
                  videoElement.addEventListener('canplay', () => {
                    statusElement.textContent = 'Video can start playing';
                  });
        
                  videoElement.addEventListener('loadeddata', () => {
                    statusElement.textContent = 'First frame loaded';
                  });
        
                  xhr.send();
                `;
                newWindow.document.body.appendChild(script);
              } else {
                console.error('Unable to open new window. Pop-up might be blocked.');
              }
        
            } else if (contentType === 'application/pdf') {
              const blob = await response.blob();
              const url = URL.createObjectURL(blob);
              window.open(url, '_blank');
            } else {
              console.log('Unsupported file type:', contentType);
            }
          } catch (error) {
            console.error('Error handling resource:', error);
        }
    }
}

export default new SecureMediaLoader()